import { saveUtmParams } from "./src/utils/attribution";

export const onInitialClientRender = () => {
  saveUtmParams({ sticky: false }); // last-touch
};

export const onRouteUpdate = () => {
  saveUtmParams({ sticky: false }); // overwrite when new UTMs appear
};
